<template lang="html">
  <v-container>
  <v-layout row wrap>

    <!-- Title -->
    <v-flex xs12>
      <v-text-field
      v-model="description.title"
      :error-messages="titleErrors"
      label="Título"
      required
      @input="$v.description.title.$touch()"
      @blur="$v.description.title.$touch()"
      ></v-text-field>
    </v-flex>

    <!-- Type toggle -->
    <v-flex xs12>
      <v-switch
       v-model="description.type"
       label="Descrição Detalhe"
       :true-value="1"
       :false-value="0"
     ></v-switch>
    </v-flex>

    <!-- Sub-Title -->
    <v-flex xs12 v-if="description.type == 1">
      <v-text-field
      v-model="description.sub_title"
      label="Sub-Título"
      ></v-text-field>
    </v-flex>

    <v-layout row>
      <!-- Image -->
      <v-flex xs2 v-if="description.type == 1">
        <file-upload v-model="description.image" />
      </v-flex>

      <!-- Content -->
      <v-flex shrink xs12>
        <vue-editor v-model="description.content" />
      </v-flex>
    </v-layout>

  </v-layout>
  </v-container>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import fileUpload from '@/components/Tools/fileUplad.vue'
export default {
  props: {
    value:{
      type: Object,
      required: true
    }
  },
  validations: {
    description:{
      title: {
        required
      },
      sub_title: {
        // required
      },
    }
  },
  computed: {
    description:{
      get: function (){
        return this.value
      },
      set: function (value) {
        this.$emit('input', value)
      }
    },
    titleErrors () {
      const errors = []
      if (!this.$v.description.title.$dirty) return errors
      !this.$v.description.title.required && errors.push('Título é obrigatório.')
      return errors
    },
    sub_titleErrors () {
      const errors = []
      if (!this.$v.description.sub_title.$dirty) return errors
      !this.$v.description.sub_title.required && errors.push('Sub-Título é obrigatório.')
      return errors
    },
  },
  components: {
    fileUpload
  }
}
</script>

<style lang="css" scoped>
</style>
